import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from '@mui/material';

export default function ProcoreWelcome() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ele = document
      .getElementsByClassName('procore-welcome')[0]
      .getElementsByTagName('a')[0];

    if (ele) {
      ele.addEventListener('click', () => {
        setOpen(true);
      });
    }
  });

  return (
    <div id="procore-wecome-react">
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{'Configure later?'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You will need to finish configuring your Procore Integration later
            at
            <br />
            <b>
              Admin -{'>'} Integrations -{'>'} Procore
            </b>
          </DialogContentText>
          <DialogContentText>Are you sure?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            No
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              document.location.href = '/';
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
